export default "__VITE_ASSET__fAOrqGE2__"